var _defs, _g, _g2, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnarchyImsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 195",
    width: 220,
    height: 195,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "ringGap"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 195,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 64,
    r: 42,
    fill: "none",
    stroke: "#000",
    strokeWidth: 14.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#5FC39C",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 10 L80 116",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 10 L140 116",
    strokeWidth: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ringGap)",
    fill: "none",
    stroke: "#5FC39C",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 2 V10",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 64 H96",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 64 H174",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 92 V128",
    strokeWidth: 4.5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 64,
    r: 42,
    fill: "none",
    stroke: "#5FC39C",
    strokeWidth: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 64,
    r: 3,
    fill: "#5FC39C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0 182 L17.0 150 L29.0 182",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0 182 V150 L60.0 182 V150",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0 182 L79.0 150 L91.0 182",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0 182 V150 H114.0 A8.0 8.0 0 0 1 114.0 166.0 H98.0 M110.0 166.0 L122.0 182",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.3 155.7 A16.0 16.0 0 1 0 153.3 176.3",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.0 150 V182 M184.0 150 V182 M160.0 166.0 H184.0",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.0 150 L203.0 166.0 L215.0 150 M203.0 166.0 V182",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnarchyImsLogo);
export default __webpack_public_path__ + "static/media/anarchy-ims-logo.853fe656d8c71037ae0949cbb4274786.svg";
export { ForwardRef as ReactComponent };